module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.69eac499e9311b03ed69199e62ea962e.ttf?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.ttf
// module id = 739
// module chunks = 9